import React, { Component } from "react";

// Assets
import CalcLogo from "../../Assets/edit.svg";
import triangle1 from "../../Assets/triangle1.svg";
import triangle2 from "../../Assets/triangle2.svg";
import triangle3 from "../../Assets/triangle3.svg";
import circle1 from "../../Assets/circle1.svg";
import circle2 from "../../Assets/circle2.svg";
import circle3 from "../../Assets/circle3.svg";
import rectangle1 from "../../Assets/rectangle1.svg";
import rectangle2 from "../../Assets/rectangle2.svg";
import rectangle3 from "../../Assets/rectangle3.svg";

export default class PreGlucose extends Component {
  render() {
    return (
      <div className="Calculation_PreGlucose">
        <img id="_1" src={triangle1} />
        <img id="_2" src={triangle2} />
        <img id="_3" src={triangle3} />
        <img id="_4" src={circle1} />
        <img id="_5" src={circle2} />
        <img id="_6" src={circle3} />
        <img id="_7" src={rectangle1} />
        <img id="_8" src={rectangle2} />
        <img id="_9" src={rectangle3} />
        <div className="Calculation_PreGlucoseBlock">
          <div className="Calculation_PreGlucoseTitle">
            Enter Your Pre-Glucose Level
          </div>
          <div className="Calculation_PreGlucoseDesc">
            For calculating insulin dose as per your’s food intake we need to
            know your pre glucose level
          </div>
          <div className="Calculation_PreGlucoseInputField">
            <input
              className="Calculation_PGInputField"
              type="text"
              onKeyPress={(event) =>
                event.key !== " " && event.key >= 0 && event.key <= 9
                  ? true
                  : event.preventDefault()
              }
            />
          </div>
          <div className="Calculation_PGButtons">
            <button className="Calculation_PGClear">Clear</button>
            <button
              className="Calculation_PGSubmit"
              onClick={() => {
                this.props.renderPage(4);
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}
